<template>
  <div>
    <label class="control-label"
      >{{ title }}
      <span v-show="tempUpload" @click="clear" class="bold">
        - Отмена</span
      ></label
    >
    <div class="media-input">
      <div>
        <audio controls v-if="value">
          <source :src="value" type="audio/mpeg" />
        </audio>
      </div>

      <div>
        <input
          class="d-block mt-2 ml-3"
          ref="fileupload"
          type="file"
          :name="`${name}_audio`"
          @change="handleFileUpload"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    tempUpload: false,
    oldData: null,
    noImage: require("@/assets/img/no-photo-available.png"),
  }),
  watch: {
    lastUpdate(val) {
      if (val) {
        this.tempUpload = false;
        this.$refs.fileupload.value = null;
      }
    },
  },
  computed: {
    ...mapState(["lastUpdate"]),
  },
  props: {
    title: {
      default: "",
    },
    value: {
      default: null,
    },
    name: {
      default: null,
    },
  },
  created() {
    this.oldData = this.value;
  },
  methods: {
    clear() {
      this.tempUpload = false;
      this.$refs.fileupload.value = null;
      this.$emit("input", this.oldData);
    },
    async handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        if (file.size > 51000000) {
          this.$notify({
            title: "Ошибка",
            message: "Файл более 50 мб. весит",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error",
          });
          return false;
        }
        this.$emit("input", file);
        // const reader = new FileReader();
        // reader.readAsDataURL(file);
        // await reader.addEventListener("load", () => {
        //   this.$emit("input", reader.result);
        // });
      }
    },
  },
};
</script>
<style lang="scss">
.media-input {
  display: flex;
  // justify-content: center;
  align-content: center;
}
</style>